/**
 * Role-Based Access Control Utilities for Frontend
 */

// Get user roles from Keycloak token
export const getUserRoles = (keycloak) => {
  if (!keycloak?.authenticated || !keycloak?.tokenParsed) {
    return [];
  }
  return keycloak.tokenParsed.realm_access?.roles || [];
};

// Check if user has a specific role (Case Insensitive)
export const hasRole = (keycloak, role) => {
  const roles = getUserRoles(keycloak);
  // Normalize everything to lowercase for robust comparison
  const normalizedRoles = roles.map((r) => r.toLowerCase());
  return normalizedRoles.includes(role.toLowerCase());
};

// Check if user has any of the specified roles (Case Insensitive)
export const hasAnyRole = (keycloak, rolesList) => {
  const roles = getUserRoles(keycloak);
  const normalizedUserRoles = roles.map((r) => r.toLowerCase());
  const normalizedRequiredRoles = rolesList.map((r) => r.toLowerCase());

  return normalizedRequiredRoles.some((role) => normalizedUserRoles.includes(role));
};

// Check if user is superadmin
export const isSuperadmin = (keycloak) => {
  return hasRole(keycloak, 'superadmin');
};

// Check if user is admin or superadmin
// Logic: Superadmin IS an Admin + more
export const isAdmin = (keycloak) => {
  // Explicitly check if user has 'admin' role OR 'superadmin' role
  return hasRole(keycloak, 'admin') || hasRole(keycloak, 'superadmin');
};

// Check if user is regular user
export const isUser = (keycloak) => {
  return hasRole(keycloak, 'user');
};

// Get highest role (for display purposes)
export const getHighestRole = (keycloak) => {
  if (isSuperadmin(keycloak)) return 'superadmin';
  if (isAdmin(keycloak)) return 'admin';
  if (isUser(keycloak)) return 'user';
  return 'guest';
};

export default {
  getUserRoles,
  hasRole,
  hasAnyRole,
  isSuperadmin,
  isAdmin,
  isUser,
  getHighestRole,
};
